module.exports = __webpack_public_path__ + "img/01-thumb.7430e746.jpg";